export class ProductPricingV2 {

    public id: number;
    public p90: string;
    public p50p90: string;
    public p50: string;
    public p10p50: string;
    public p10: string;
    public contractLength: string;
    public invoicingMode: string;
    public frequency: string;
    public minQuantity: string;
    public maxQuantity: string;
    public exchangeRule: string;
    public numberOfChange: string;
    public frequencies: string[];
    public invoicingModes: string[];
    public numberOfChanges: string[];
    //for CMC
    public stockVT: string;
    public extraPrice: string;
    public forfaitCode: string;
    public forfaitLabel: string;
    public contractType: string;
    public unitOfMeasure: string;
    public franchiseConso: string;

    public get productPricingDetails() {
        return {
            'contractDuration': this.contractLength,
            'billingMode': (this.invoicingModes ?? this.invoicingMode) as string,
            'frequency': (this.frequencies ?? this.frequency) as string,
            'numberOfChange': (this.numberOfChanges ?? this.numberOfChange) as string,
            'exchangeRule': this.exchangeRule,
            'quantityMax': this.maxQuantity,
            'quantityMin': this.minQuantity,
            'extraPrice': this.extraPrice,
            'forfaitCode': this.forfaitCode,
            'forfaitLabel': this.forfaitLabel,
            'contractType': this.contractType,
            'unitOfMeasure': this.unitOfMeasure,
            'franchiseConso': this.franchiseConso,
            'stockVT': this.stockVT
        }
    }

}